import { TicketWithDetailsDto } from '@sib/api';
import { useDateFormat } from '@spendbrain/core/utils/use-date-formats';
import { useAppTranslation } from '@spendbrain/modules/tickets/hooks';
import { useStatusLabelKeys } from '@spendbrain/modules/tickets/pages';
import { format } from 'date-fns';
import { TicketDetailWrapper } from '../TicketDetailWrapper';

interface TicketSubjectSectionProps {
  ticket?: TicketWithDetailsDto;
}

export const TicketSubjectSection = ({ ticket }: TicketSubjectSectionProps) => {
  const { t } = useAppTranslation();
  const dateFormat = useDateFormat();
  const dueDate = new Date(ticket?.dueDate || '');
  const statusLabelKeys = useStatusLabelKeys();

  const date = ticket?.dueDate
    ? format(dueDate, dateFormat.defaultDateFormat)
    : '';

  return (
    <div className="flex justify-between gap-3">
      <TicketDetailWrapper
        label={t('components.ticketDetails.subject.subject')}
        className="w-1/2 break-all"
      >
        {ticket?.subject}
      </TicketDetailWrapper>

      <div className="flex w-1/2 gap-14">
        <TicketDetailWrapper
          label={t(`components.ticketDetails.subject.dueDate`)}
          className="w-1/2"
        >
          {date || <p className="text-xs">{t('noData')}</p>}
        </TicketDetailWrapper>
        <TicketDetailWrapper
          label={t(`components.ticketDetails.subject.status`)}
          className="w-1/2"
        >
          {ticket?.status ? (
            statusLabelKeys[ticket?.status]
          ) : (
            <p className="text-xs">{t('noData')}</p>
          )}
        </TicketDetailWrapper>
      </div>
    </div>
  );
};
